module.exports = __webpack_public_path__ + "static/background-4-93524a5b63eb24b93d631a985bd171d1.png";